import React, { useContext, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  FaBars,
  FaChevronDown,
  FaHome,
  FaKey,
  FaSignOutAlt,
  FaTimes,
  FaUser,
} from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';
import logo from '../../assets/diversity.png';
import ThemeSwitcher from '../common/ThemeSwitcher';
import NotificationBell from '../common/NotificationBell';
import '../../styles/components/Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const { session, loading, logout } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
    setIsOpen(false);
  };

  if (loading) {
    return <div className="app-header app-header-loading" aria-label="Loading navigation" />;
  }

  const { roles, name } = session;
  const isGuest = roles.includes('GUEST');
  const menuItems = isGuest
    ? [
        { path: '/', label: 'Home', icon: <FaHome /> },
        { path: '/login', label: 'Login', icon: <FaUser /> },
        { path: '/signup', label: 'Sign up', icon: <FaUser /> },
      ]
    : [
        { path: '/dashboard', label: 'Dashboard', icon: <FaHome /> },
        { path: '/profile', label: 'Profile', icon: <FaUser /> },
        { path: '/change-password', label: 'Password', icon: <FaKey /> },
      ];
  const primaryRole = roles.find(role => role !== 'GUEST') || 'Guest';
  const initials = (name || 'Community User')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0])
    .join('')
    .toUpperCase();

  return (
    <header className="app-header">
      <nav className="app-navbar" aria-label="Main navigation">
        <NavLink className="app-brand" to="/" onClick={() => setIsOpen(false)}>
          <span className="app-brand-mark"><img src={logo} alt="" /></span>
          <span className="app-brand-copy">
            <strong>MyCommunity</strong>
            <small>Connected living</small>
          </span>
        </NavLink>
        <button
          className="app-menu-toggle"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-controls="app-navigation"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
        <div className={`app-navigation ${isOpen ? 'is-open' : ''}`} id="app-navigation">
          <ul className="app-nav-links">
            {menuItems.map(item => (
              <li key={item.path}>
                <NavLink
                  className={({ isActive }) => `app-nav-link ${isActive ? 'is-active' : ''}`}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                >
                  <span className="app-nav-icon">{item.icon}</span>
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
          <div className="app-header-actions">{!isGuest && <NotificationBell />}<ThemeSwitcher compact /></div>
          {!isGuest && (
            <div className="app-user-area">
              <div className="app-avatar" aria-hidden="true">{initials}</div>
              <div className="app-user-copy">
                <strong>{name || 'Community member'}</strong>
                <small>{primaryRole.replace('_', ' ').toLowerCase()}</small>
              </div>
              <FaChevronDown className="app-user-chevron" aria-hidden="true" />
              <button className="app-logout" onClick={handleLogout} title="Log out" aria-label="Log out">
                <FaSignOutAlt />
              </button>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
